/**
 * ImageHighlights - image with positioned highlight hotspots.
 * Custom element: <image-highlights>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class ImageHighlights extends ThemeComponent {}
setFunctionName(ImageHighlights, "ImageHighlights");
const propertyTypes = {};
ImageHighlights.prototype.$name = "ImageHighlights";
ImageHighlights.prototype.$info = JSON.parse('{"name":"ImageHighlights","meta":{"isLegacy":false,"selector":"image-highlights"},"props":[],"refs":[]}');
ImageHighlights.prototype.$info.component = ImageHighlights;
for (const prop of ImageHighlights.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("ImageHighlights/ImageHighlights.ts", {
  ImageHighlights: ImageHighlights
}, void 0);